module.exports = __webpack_public_path__ + "img/kommune-1703.01d78a93.svg";